import { Link } from 'react-router-dom';
import '../styles/LinktreeLanding.css';

function LinktreeLanding() {
  const isProduction = process.env.NODE_ENV === 'production';

  const externalLinks = [
    { name: 'Frequently Asked Questions', url: 'https://pitch-a-friend.com/buffalo/faqs', icon: '❓' },
    { name: 'Events Calendar & Purchase Tickets', url: 'https://pitch-a-friend.com/buffalo#events', icon: '🗓️' },
    { name: 'Feedback', url: 'https://pitch-a-friend.com/buffalo/feedback', icon: '💬' },
    { name: 'Become a Brand Ambassador', url: 'https://thrybr.com', icon: '⭐' },
    { name: 'Volunteer', url: 'https://pitch-a-friend.com/buffalo/volunteer', icon: '🤝' }
  ];

  // Temporarily hide tickets button in production
  if (!isProduction) {
    externalLinks.push({ name: 'Buy Tickets Here', url: '#', icon: '🎟️' });
  }

  return (
    <div className="linktree-container">
      <div className="linktree-content">
        <div className="linktree-header">
          <img
            src="/assets/paf-buffalo-logo.png"
            alt="Pitch A Friend Logo"
            className="main-logo"
          />
          <h1>Pitch-A-Friend</h1>
          <h2>Buffalo, NY</h2>
          <p className="tagline">Make meaningful connections and experience a community event for singles like no other.</p>

          <div className="social-icons">
            <a
              href="https://instagram.com/pitchafriend.buffalo"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon-btn social-icon-instagram"
              aria-label="Follow us on Instagram"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            <a
              href="https://www.tiktok.com/@pitchafriend.buffalo"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon-btn social-icon-tiktok"
              aria-label="Follow us on TikTok"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.16 8.16 0 004.77 1.52V6.75a4.85 4.85 0 01-1-.06z"/>
              </svg>
            </a>
          </div>
        </div>

        <div className="links-container">
          {/* Primary CTA */}
          <a
            href="https://pitch-a-friend.com/buffalo/signup"
            target="_blank"
            rel="noopener noreferrer"
            className="link-button internal-link sign-in"
          >
            <span className="link-icon">✍️</span>
            <span className="link-text sign-in-text">
              Sign Up To Pitch
              <span className="sign-in-sub">Create your free profile on pitch-a-friend.com</span>
            </span>
          </a>

          {/* Secondary CTA — venue owners */}
          <a
            href="https://calendar.app.google/TrMBMxSGQ1EziVaN9"
            target="_blank"
            rel="noopener noreferrer"
            className="link-button venue-booking"
          >
            <span className="link-icon">📞</span>
            <span className="link-text">Book a call to host Pitch-A-Friend at your venue</span>
          </a>

          {/* Pitch Template Download */}
          <a
            href="https://cdn1.thrybr.com/pitch-a-friend/presentations/Pitch-A-Friend_Buffalo_Template.pptx"
            target="_blank"
            rel="noopener noreferrer"
            className="link-button pitch-template"
          >
            <span className="link-icon">⬇️</span>
            <span className="link-text">
              Download Pitch Template
              <span className="pitch-template-sub">Get our presentation guide to craft a winning pitch</span>
            </span>
          </a>

          {/* Section divider */}
          <div className="links-divider">
            <span className="links-divider-label">More Info</span>
          </div>

          {/* External Links */}
          {externalLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="link-button external-link"
            >
              <span className="link-icon">{link.icon}</span>
              <span className="link-text">{link.name}</span>
            </a>
          ))}
        </div>

        <div className="powered-by">
          <span className="powered-by-text">
            Technology built with ❤️ by
          </span>
          <a
            href="https://thrybr.com"
            target="_blank"
            rel="noopener noreferrer"
            className="thrybr-link"
          >
            <img
              src="/assets/thrybr-logo.svg"
              alt="Thrybr"
              className="thrybr-logo"
            />
          </a>
        </div>
      </div>
    </div >
  );
}

export default LinktreeLanding;
